export const text = [
    {
        summary: 'When you feel it',
        details: [
            {
                summary: 'It hits you',
                details: [
                    "Unrelenting",
                    "Unending",
                    "Embrace",
                ],
            },
            {
                summary: 'It grabs you',
                details: [
                    {
                        summary: 'You see it all',
                        details: [
                            {
                                summary: 'Can you describe it?',
                                details: [
                                    "I forget",
                                ],
                            },
                        ],
                    },
                    {
                        summary: 'You see nothing',
                        details: [
                            "It was nothing, after all",
                        ],
                    },
                ],
            }
        ]
    }
];

export default text;